<template>
  <layout-apply-cancel @cancel="cancel" @apply="applyClick">
  </layout-apply-cancel>
</template>

<script>
/** (GW)
 * Asset Editor's audio apply cancel (top bar)
 * Emits apply event to parent assetEditorVue
 * Dispatches changeCurrentEffect
 */
import LayoutApplyCancel from 'AssetEditor/layouts/LayoutApplyCancel.vue';
import bus from 'v/AssetEditor/AssetEditorEventBus';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

export default {
  components: {
    LayoutApplyCancel,
  },

  computed: {
    ...mapState('assetEditor', ['applyVolumeToAll']),
    ...mapGetters('assetEditor', [
      'workModel',
      'assetModel',
      'confirmedVolumeApplyAll',
    ]),

    hasValidAudio() {
      return this.assetModel.get('hasValidAudio');
    },
    originalVolumeControl() {
      return this.workModel.volumeControl;
    },
    originalOnVoPlayVolumeControl() {
      return this.workModel.onVoPlayVolumeControl;
    },
  },

  methods: {
    ...mapMutations('assetEditor', [
      'setVolumeControl',
      'setConfirmedVolumeApplyAll',
      'setApplyVolumeToAll',
    ]),
    ...mapActions('assetEditor', ['allowToNavigateAway', 'changeCurrentPage']),

    cancel() {
      this.setVolumeControl({
        volumeControl: this.originalVolumeControl,
        onVoPlayVolumeControl: this.originalOnVoPlayVolumeControl,
      });
      this.setApplyVolumeToAll(this.applyVolumeToAll);
      this.allowToNavigateAway(true);
      this.changeCurrentPage('preview');
    },

    applyClick() {
      if (!this.applyVolumeToAll) {
        this.setConfirmedVolumeApplyAll(false);
      }
      if (this.applyVolumeToAll && !this.confirmedVolumeApplyAll) {
        const description = this.hasValidAudio
          ? 'Changes will apply to all video assets currently on your timeline.'
          : 'Changes will apply to all non-video assets currently on your timeline.';

        app.dialog
          .confirm(
            {
              type: app.dialog.types.CONFIRM_3,
              title: 'Apply to All?',
              buttonYesText: 'OK',
              description,
            },
            {
              wrapperStyle: {
                zIndex: 2055,
              },
            }
          )
          .then((data) => {
            if (data.action) {
              bus.$emit('apply-click');
              this.setConfirmedVolumeApplyAll(true);
            }
          });
      } else {
        bus.$emit('apply-click');
      }
    },
  },
};
</script>
